import { CouponTypes } from "../types/coupons";

export const checkIsPrizeExist = (state: any) => {
  const arr = ["prize", "fixedOdds", "raffle"];
  const errArr: Array<boolean> = [];
  for (let i = 0; i < arr.length; i++) {
    if (!!state[arr[i]] && state[arr[i]].length === 0) {
      errArr.push(false);
    } else {
      errArr.push(true);
    }
  }

  if (errArr.findIndex((value) => value === true) !== -1) {
    return true;
  } else {
    return false;
  }
};

const checkIsBasketAndFixedOddsTicetsValid = (state) => {
  const isBothExist = state.basketAmount && state.fixedOddsTickets;
  const isBothEnteredWithValidValues =
    !(state.basketAmount && state.basketAmount >= 0) &&
    !(state.fixedOddsTickets && state.fixedOddsTickets > 0);

  if (isBothExist || isBothEnteredWithValidValues) {
    return true;
  } else {
    return false;
  }
};

const GetCouponValueFieldErrorState = (
  state,
  fixedOddsArr: Array<{ id: string; title: string; maxTickets: number }> = []
) => {
  if (!(state.value <= 0)) {
    if (state.type === CouponTypes.Basket && state.value > 100) {
      return { status: true, message: "Value should be less than 100" };
    }

    if (state.type === CouponTypes.FixedOdds) {
      const fixedOdd = fixedOddsArr?.find(
        (item) => item.id === state.fixedOdds
      );
      if (fixedOdd && fixedOdd.maxTickets < state.value) {
        return {
          status: true,
          message: `Tickets value for this prize should be less than ${fixedOdd.maxTickets}`,
        };
      }
    }

    return { status: false, message: "" };
  } else {
    return {
      status: true,
      message: "Value should be bigger than 0",
    };
  }
};

const GetCouponPrizeFieldErrorState = (state) => {
  if (
    state.type === CouponTypes.Prize ||
    state.type === CouponTypes.FixedOdds ||
    state.type === CouponTypes.DreamHome
  ) {
    if (!checkIsPrizeExist(state)) {
      return { status: true, message: "Field is required" };
    } else {
      return { status: false, message: "" };
    }
  } else {
    return { status: false, message: "" };
  }
};

const GetCouponConditionFieldsErrorState = (state) => {
  return (
    (state.type === CouponTypes.DreamHome && {
      status: checkIsBasketAndFixedOddsTicetsValid(state),
      message: "Only one value should be entered",
    }) || {
      status: !state.basketAmount && !state.fixedOddsTickets ? true : false,
      message: "Field is required",
    }
  );
};

export const CouponHelpers = {
  GetCouponConditionFieldsErrorState,
  GetCouponValueFieldErrorState,
  GetCouponPrizeFieldErrorState,
};
